module.exports = __webpack_public_path__ + "components/media-kit/static/icon-facebook-6de5c59eefb24a75b989c82916d75f78.svg";